export const VITE_API_URL = import.meta.env.VITE_API_URL;

export const VITE_STRAPI_URL = import.meta.env.VITE_STRAPI_URL;
